module.exports = __webpack_public_path__ + "img/lg_ring_y_o_1_null@2x.6df31221.png";